/** @format */

import { Card, Col, Row, Spin } from "antd";
import { ILoginFormProps } from "./LoginForm/LoginForm.types";
import { ITwoFALoginFormProps } from "./TwoFALoginForm/TwoFALoginForm.types";
import { ITermsOfServiceModalProps } from "./TermsOfServiceModal/TermsOfServiceModal.types";
import { Link } from "react-router-dom";
import LoginForm from "./LoginForm";
import TwoFALoginForm from "./TwoFALoginForm";
import React from "react";
import TermsOfServiceModal from "./TermsOfServiceModal";
import { IAppPropsStore } from "../../redux/appPropsReducer/types";
import {
	ArrowLeftOutlined
} from "@ant-design/icons";

interface IProps {
	appProps: IAppPropsStore;
	isSpinningLoginCard: boolean;
	isSpinningTermsOfServiceModal: boolean;
	loginFormProps: ILoginFormProps;
	termsOfServiceModalProps: ITermsOfServiceModalProps;
	twoFALoginProps: ITwoFALoginFormProps;
	isTwoFALogin: boolean;
	handleCloseTwoFAClick: () => void;
	handleEmailOtp: () => void;
}

const LoginContentView: React.FC<IProps> = ({
	appProps,
	isSpinningLoginCard,
	isSpinningTermsOfServiceModal,
	loginFormProps,
	termsOfServiceModalProps,
	twoFALoginProps,
	isTwoFALogin,
	handleCloseTwoFAClick,
	handleEmailOtp,
}) => (
	<div className="authentication-page">
		<div className="form-div">
			<Spin spinning={isSpinningLoginCard}>
				<Card style={isTwoFALogin ? { width: "400px", height: "270px"} : { width: "320px" }}>
				{isTwoFALogin ? <ArrowLeftOutlined  style={{ fontSize: '24px', marginLeft: "-12px", marginTop: "-12px" }} onClick={handleCloseTwoFAClick}/> : null}
					<Row style = {isTwoFALogin ? {justifyContent : "center"} : {}}>
						<Col>
							{isTwoFALogin 
								? 
								<TwoFALoginForm {...twoFALoginProps} /> 
								:
								<LoginForm {...loginFormProps} />
							}
						</Col>
					</Row>
					<Row justify="space-between" style={{ display: "flex", justifyContent: isTwoFALogin ? "center" : "" }}>
						<Col>
							{isTwoFALogin ? 
							<a
								onClick={handleEmailOtp}
								rel="noopener noreferrer"
								target="_blank">
								Email me the one time token instead
							</a> :
							<a
								href={`${appProps.ssoClientUrl}/forgot-password`}
								rel="noopener noreferrer"
								target="_blank">
								Forgot password
							</a>
							}
						</Col>
						{/* <Col>
							<Link to="/register">Register</Link>
						</Col> */}
					</Row>
				</Card>
			</Spin>
			<Spin spinning={isSpinningTermsOfServiceModal}>
				<TermsOfServiceModal {...termsOfServiceModalProps} />
			</Spin>
		</div>
	</div>
);

export default LoginContentView;
